import { useState } from 'react';
import { Tool } from '../../types/mspaints.tsx';
import { Toolbar } from './Toolbar';
import { useCanvas } from '../../hooks/useCanvas';

export function Paint() {
    const [tool, setTool] = useState<Tool>('brush');
    const [color, setColor] = useState('#000000');
    const [speed, setSpeed] = useState(0.5);
    const [pixelInfo, setPixelInfo] = useState<string>('');
    const { canvasRef, ctx, isDrawing, setIsDrawing, getMousePosition, floodFill, clearCanvas } = useCanvas();

    const startDrawing = (e: React.MouseEvent) => {
        if (!ctx) return;

        const point = getMousePosition(e);
        if (!point) return;

        if (tool === 'fill') {
            floodFill(point, color, setPixelInfo, speed);
        } else {
            setIsDrawing(true);
            ctx.beginPath();
            ctx.moveTo(point.x, point.y);
        }
    };

    const draw = (e: React.MouseEvent) => {
        if (!isDrawing || !ctx || tool === 'fill') return;

        const point = getMousePosition(e);
        if (!point) return;

        ctx.lineTo(point.x, point.y);
        ctx.strokeStyle = tool === 'eraser' ? '#ffffff' : color;
        ctx.lineWidth = tool === 'eraser' ? 20 : 2;
        ctx.lineCap = 'round';
        ctx.stroke();
    };

    const stopDrawing = () => {
        if (!ctx) return;
        setIsDrawing(false);
        ctx.closePath();
    };

    return (
        <div className="bg-white p-6 rounded-lg shadow-lg">
            <Toolbar
                tool={tool}
                color={color}
                speed={speed}
                onToolChange={setTool}
                onColorChange={setColor}
                onSpeedChange={setSpeed}
                onClear={clearCanvas}
            />
            <div className="relative">
                <canvas
                    ref={canvasRef}
                    width={600}
                    height={400}
                    className="border border-gray-300 cursor-crosshair"
                    onMouseDown={startDrawing}
                    onMouseMove={draw}
                    onMouseUp={stopDrawing}
                    onMouseLeave={stopDrawing}
                />
                {pixelInfo && (
                    <div className="absolute top-2 right-2 bg-black/75 text-white p-2 rounded text-sm font-mono whitespace-pre">
                        {pixelInfo}
                    </div>
                )}
            </div>
        </div>
    );
}